"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getConsumingUXCoreVersion;
var _coerce = _interopRequireDefault(require("semver/functions/coerce"));
function getConsumingUXCoreVersion() {
  var _window, _window$ux;
  var windowVersion = (_window = window) === null || _window === void 0 ? void 0 : (_window$ux = _window.ux) === null || _window$ux === void 0 ? void 0 : _window$ux.versions['ux/uxcore2'];
  if (windowVersion) {
    var _semverCoerce;
    var consumingVersion = (_semverCoerce = (0, _coerce.default)(windowVersion)) === null || _semverCoerce === void 0 ? void 0 : _semverCoerce.version;
    return consumingVersion;
  }
  return '';
}